import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sv',
  months: [
    'januari',
    'februari',
    'mars',
    'april',
    'maj',
    'juni',
    'juli',
    'augusti',
    'september',
    'oktober',
    'november',
    'december',
  ],
  monthsShort: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  weekdays: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
  weekdaysMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  weekdaysShort: ['sön.', 'mån.', 'tis.', 'ons.', 'tors.', 'fre.', 'lör.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'YYYY-MM-DD',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'YYYY-MM-DD',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd D MMM YYYY HH:mm',
    'llll-Y': 'ddd D MMM HH:mm',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'fm', pm: 'em', AM: 'fm', PM: 'em' },
  past: {
    y: { one: 'för %s år sen', other: 'för %s år sen' },
    M: { one: 'för %s mån. sen', other: 'för %s mån. sen' },
    w: { one: 'för %s v. sedan', other: 'för %s v. sedan' },
    d: { one: 'för %s d sedan', other: 'för %s d sedan' },
    h: { one: 'för %s tim sedan', other: 'för %s tim sedan' },
    m: { one: 'för %s min sen', other: 'för %s min sen' },
    s: { one: 'för %s s sen', other: 'för %s s sen' },
  },
  future: {
    y: { one: 'om %s år', other: 'om %s år' },
    M: { one: 'om %s mån.', other: 'om %s mån.' },
    w: { one: 'om %s v.', other: 'om %s v.' },
    d: { one: 'om %s d', other: 'om %s d' },
    h: { one: 'om %s tim', other: 'om %s tim' },
    m: { one: 'om %s min', other: 'om %s min' },
    s: { one: 'om %s sek', other: 'om %s sek' },
  },
  pastLong: {
    y: { one: 'för %s år sedan', other: 'för %s år sedan' },
    M: { one: 'för %s månad sedan', other: 'för %s månader sedan' },
    w: { one: 'för %s vecka sedan', other: 'för %s veckor sedan' },
    d: { one: 'för %s dag sedan', other: 'för %s dagar sedan' },
    h: { one: 'för %s timme sedan', other: 'för %s timmar sedan' },
    m: { one: 'för %s minut sedan', other: 'för %s minuter sedan' },
    s: { one: 'för %s sekund sedan', other: 'för %s sekunder sedan' },
  },
  futureLong: {
    y: { one: 'om %s år', other: 'om %s år' },
    M: { one: 'om %s månad', other: 'om %s månader' },
    w: { one: 'om %s vecka', other: 'om %s veckor' },
    d: { one: 'om %s dag', other: 'om %s dagar' },
    h: { one: 'om %s timme', other: 'om %s timmar' },
    m: { one: 'om %s minut', other: 'om %s minuter' },
    s: { one: 'om %s sekund', other: 'om %s sekunder' },
  },
  abbr: {
    y: { one: '%s år', other: '%s år' },
    M: { one: '%s mån', other: '%s mån' },
    w: { one: '%s v', other: '%s v' },
    d: { one: '%s d', other: '%s d' },
    h: { one: '%s tim', other: '%s tim' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s sek', other: '%s sek' },
  },
  full: {
    y: { one: '%s år', other: '%s år' },
    M: { one: '%s månad', other: '%s månader' },
    w: { one: '%s vecka', other: '%s veckor' },
    d: { one: '%s dag', other: '%s dagar' },
    h: { one: '%s timme', other: '%s timmar' },
    m: { one: '%s minut', other: '%s minuter' },
    s: { one: '%s sekund', other: '%s sekunder' },
  },
  justNow: 'just nu',
  yesterday: 'Igår',
  today: 'Idag',
  tomorrow: 'Imorgon',
  weekStart: 1,
  timeRange: '%$1s–%$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd DD MMM YYYY', end: 'ddd DD MMM YYYY' },
    'Y-1': { start: 'ddd DD MMM', end: 'ddd DD MMM YYYY' },
    M: { start: 'ddd D MMM', end: 'ddd D MMM' },
    D: { start: 'ddd D MMM', end: 'ddd D MMM' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'sv';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => {
    const b = n % 10;
    const o = b === 1 || b === 2 ? 'a' : 'e';
    return `[${n}${o}]`;
  },
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'fm' : 'fm';
    } else {
      return isLowerCase ? 'em' : 'em';
    }
  },
};
